module.exports = __webpack_public_path__ + "img/eco.62937fd1.png";